// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"02b9cf81","20":"02b9cf81","190":"2f5c62a8","257":"02b9cf81","281":"02b9cf81","393":"86d2a111","444":"86d2a111","710":"02b9cf81","927":"02b9cf81"}[chunkId] + ".chunk.css";
};